import { render, staticRenderFns } from "./successionVoucher.vue?vue&type=template&id=530b7e5f&scoped=true&"
var script = {}
import style0 from "./successionVoucher.vue?vue&type=style&index=0&id=530b7e5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b7e5f",
  null
  
)

export default component.exports